/**
 * Returns the URL prefix the current public-booking page is mounted under.
 *
 *   /<orgSlug>/locations          → ''        (hosted, full Invitey chrome)
 *   /embed/<orgSlug>/locations    → '/embed'  (iframe embed, no chrome)
 *
 * Public-booking pages use this to build their internal links so the
 * embed-mode breadcrumb stays inside the iframe.
 */

import { useLocation } from 'react-router-dom';

export function useUrlPrefix(): '' | '/embed' {
  const { pathname } = useLocation();
  return pathname.startsWith('/embed/') || pathname === '/embed' ? '/embed' : '';
}
